import classNames from 'classnames';

const SepBanner = ({
    maincopy,
    learnmorecopy,
    learnmoreanchorname,
    backgroundsurface = 'bg-surface-0',
    textcolor = 'text-primary-dark',
}: {
    maincopy: string;
    learnmorecopy: string;
    learnmoreanchorname: string;
    backgroundsurface: SupportedBackgroundColor;
    textcolor?: SupportedTextColor;
}) => {
    return (
        <div
            className={classNames(
                backgroundsurface,
                textcolor,
                'text-center font-poppins text-14 md:text-18 leading-20 md:leading-28 px-4 py-2 border-t-2 border-b-2 border-surface-primary-darker'
            )}
        >
            {maincopy}{' '}
            <a
                href={'#' + learnmoreanchorname}
                className="text-link"
                aria-label="Learn more about Medicare special election period"
            >
                {learnmorecopy}
            </a>
        </div>
    );
};

export default SepBanner;
